export const ClockIcon = (props) => (
  <svg fill="none" height={16} viewBox="0 0 24 24" width={16} xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx={12} cy={12} r={9} stroke="currentColor" strokeWidth={2} />
    <path d="M12 7.5V12l3 1.8" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} />
  </svg>
);
